import BusinessFaq from "components/business/businessFaq";
import BusinessGrid from "components/business/businessGrid";
import BusinessOne from "components/business/businessOne";
import BusinessSteps from "components/business/businessSteps";
import BusinessCta from "components/business/businessCta";
import Hero from "components/business/hero";
import Head from "next/head";
import styled from "styled-components";
import PricingBusiness from "./pricing-business";

const StyledWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const Features = () => {
  return (
    <>
      <Head>
        <title>Redact Enterprise - Mass Delete Business Social Media</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Use Redact to monitor, audit, and manage your company's social media digital footprint. Book a free Redact.dev demo to reduce risk and maintain compliance."
        />
        <meta name="keywords" content="redact mass delete enterprise social media" />

        <meta property="og:title" content="Redact Enterprise - Mass Delete Business Social Media" />
        <meta
          property="og:description"
          content="Use Redact to monitor, audit, and manage your company's social media digital footprint. Book a free Redact.dev demo to reduce risk and maintain compliance."
        />

        <meta property="og:url" content="https://www.redact.dev/business" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      {/* <StyledWrapper>
        <Hero />
        <BusinessOne />
        <BusinessGrid />
        <BusinessSteps />
        <BusinessFaq />
        <BusinessCta />
      </StyledWrapper> */}
      <PricingBusiness />
    </>
  );
};

export default Features;
